import React from 'react'

import PropTypes from 'prop-types'

import './chapters-active.css'

const ChaptersActive = (props) => {
  return (
    <div className={`chapters-active-thq-chapters-elm ${props.rootClassName} `}>
      <div className="chapters-active-thq-active-elm">
        <div className="chapters-active-thq-content-elm">
          <img
            alt="image"
            src={props.image}
            className="chapters-active-image"
          />
          <div className="chapters-active-thq-text-elm">
            <div className="chapters-active-container">
              <span className="chapters-active-text1">{props.chapter}</span>
              <div className="chapters-active-thq-divider-elm"></div>
              <span className="chapters-active-text2">{props.index}</span>
            </div>
            <span className="chapters-active-text3">{props.name}</span>
          </div>
        </div>
        <div className="chapters-active-thq-width-elm"></div>
        <div className="chapters-active-thq-height-elm"></div>
      </div>
    </div>
  )
}

ChaptersActive.defaultProps = {
  image: '/nav patterns/test.svg',
  rootClassName: '',
  chapter: 'Chapter 01',
  name: 'Ambassador Program',
  index: '08',
}

ChaptersActive.propTypes = {
  image: PropTypes.string,
  rootClassName: PropTypes.string,
  chapter: PropTypes.string,
  name: PropTypes.string,
  index: PropTypes.string,
}

export default ChaptersActive
